import { type FC } from 'react'

import type { SideMenuFooterProps } from './types'

/**
 * SideMenu.Footer — slot for additional footer actions (logout, settings, etc.).
 *
 * The internal collapse toggle is auto-rendered by SideMenu just below
 * this slot (desktop only).
 */
export const SideMenuFooter: FC<SideMenuFooterProps> = ({ children }) => (
  <div className="side-menu-footer-slot">{children}</div>
)

SideMenuFooter.displayName = 'SideMenuFooter'
